<template>
  <tr>
    <td>
      {{ item.name }}
    </td>

    <td>
      {{ creationDate }}
    </td>

    <td>
      <login-personalize-list-item-actions :item="item"
                                           @deleted="emitDeleted" />
    </td>

  </tr>
</template>

<script>
import LoginPersonalizeListItemActions from "@components/modules/login-personalize/list/item/actions/LoginPersonalizeListItemActions";

export default {
  components: {
    LoginPersonalizeListItemActions,
  },

  data() {
    return {};
  },

  props: {
    item: {
      type: Object,
      required: true,
    },
  },

  computed: {
    creationDate() {
      return this.$date.format(this.item.creationDate);
    },
  },

  methods: {
    emitDeleted() {
      this.$emit("deleted");
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
